<div id="heading"><h5>Templates</h5></div>

<div>

    <div *ngFor="let temp of templates;let j = index"  [ngStyle]="{'background-color': temp.backgorund}"  class="card-container Themebody">
      <div class="card-header"><strong>Questions</strong> <input (click)="selectTheme($event,temp.theme,j)" [checked]="temp.ischecked" type="checkbox" style="float:right;" aria-label="Checkbox" name="theme1" /></div>
      <div class="card-body">
        <div *ngFor="let anstemp of temp.answerthemes;let j = index">
          <div [id]="anstemp.Id">Answers</div>
        </div>
      </div>
    </div>

</div>







<!--<div id="heading"><h5>Templates</h5></div>
<div style="width:70%; height: 50%; position: absolute;">
  <div style="border-radius: 10px;background-color: #B5D4BD; width: 20%; height: 50%; float:left; margin-left: 4%;" class="card-container">
    <div class="card-header"><b>Questions</b> <input (click)="selectTheme($event,'Theme1')" [checked]="" type="checkbox" style="float:right;" name="theme1" /></div>
    <div class="card-body">
      <div id="theme1">Answers</div>
      <div id="theme1">Answers</div>
    </div>
  </div>
  <div style="border-radius: 10px;background-color: #C6BBF9; width: 20%; height: 50%; float: left;margin-left: 4%;" class="card-container">
    <div class="card-header"><b>Questions</b> <input (click)="selectTheme($event,'Theme2')" [checked]="" type="checkbox" style="float:right;" name="theme1" /></div>
    <div class="card-body">
      <div id="theme2">Answers</div>
      <div id="theme2">Answers</div>
    </div>
  </div>
  <div style="border-radius: 10px;background-color: #F0DFBD; width: 20%; height: 50%; float: left; margin-left: 4%;" class="card-container">
    <div class="card-header"><b>Questions</b> <input (click)="selectTheme($event,'Theme3')" type="checkbox" style="float:right;" name="theme1" /></div>
    <div class="card-body">
      <div id="theme3">Answers</div>
      <div id="theme3">Answers</div>
    </div>
  </div>
</div>-->
